var map = {
	"./AlignMirror.PNG": 10998,
	"./CheckGameName.PNG": 64507,
	"./FollowLightV2.PNG": 63217,
	"./FollowLightV3.PNG": 38888,
	"./FollowTheLights.PNG": 27571,
	"./Lever.PNG": 11664,
	"./LeverPuzzle.PNG": 77480,
	"./LightsOut.PNG": 39021,
	"./Memory.PNG": 60131,
	"./SequenceCages.PNG": 65982,
	"./SequenceFire.PNG": 19365,
	"./SewerPuzzle.PNG": 45010,
	"./Shrine.PNG": 7827,
	"./Simon.PNG": 60726,
	"./SliderTile.PNG": 64021,
	"./WaterPuzzle.PNG": 40205,
	"./WaterPuzzle2.PNG": 67819
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21235;